/**
 * Samtycke till behandling av särskilda kategorier av personuppgifter — the
 * bilaga variant (GDPR artikel 9).
 *
 * Hangs under a bostads- or studentbostadsavtal and rides that lease's
 * signing: no party slots, no signing block. Parties and avtalsnummer are
 * overlaid from the parent lease (`derivedFromParent` slots); the special
 * categories are authored on the samtycke itself.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
import { letterheadAndFooter } from './personuppgiftsbilaga.js';
export const SAMTYCKE_TITLE = 'Samtycke till behandling av särskilda kategorier av personuppgifter · Version 2026';
export const SAMTYCKE_PREAMBLE = 'Hyresgästens samtycke till behandling av särskilda kategorier av personuppgifter (GDPR artikel 9).';
export const SAMTYCKE_STATUTE = 'Europaparlamentets och rådets förordning (EU) 2016/679 (GDPR), artikel 9';
export const SAMTYCKE_DESCRIPTION = 'Hyresgästens uttryckliga samtycke (GDPR artikel 9) till att hyresvärden behandlar särskilda kategorier av personuppgifter (känsliga personuppgifter), exempelvis uppgifter om hälsa, funktionsnedsättning eller behov av bostadsanpassning.\n\n' +
    'Används endast när sådan känslig behandling är nödvändig och inte redan följer av lag eller annan tillämplig rättslig grund. För vanlig administration av hyresförhållandet (namn, personnummer, kontakt- och betalningsuppgifter) används i stället Personuppgiftsbilagan till hyresavtalet.';
/** Preamble → avtalsref → §§ 1–8, shared by both variants. */
export function samtyckeSharedBody(variantKey) {
    return [
        { instanceId: 'preamble', blockRef: 'common.preamble@v1', input: { text: SAMTYCKE_PREAMBLE } },
        { instanceId: 'avtalsref', blockRef: `${variantKey}.avtalsref@v1`, input: {} },
        { instanceId: 'parter', blockRef: `${variantKey}.parter@v1`, input: {} },
        { instanceId: 'bakgrund', blockRef: 'samtycke_sarskilda_bilaga.bakgrund@v1', input: {} },
        { instanceId: 'uppgifter', blockRef: 'samtycke_sarskilda_bilaga.uppgifter@v1', input: {} },
        { instanceId: 'andamal', blockRef: 'samtycke_sarskilda_bilaga.andamal@v1', input: {} },
        { instanceId: 'mottagare', blockRef: 'samtycke_sarskilda_bilaga.mottagare@v1', input: {} },
        { instanceId: 'lagringstid', blockRef: 'samtycke_sarskilda_bilaga.lagringstid@v1', input: {} },
        { instanceId: 'frivillighet', blockRef: 'samtycke_sarskilda_bilaga.frivillighet@v1', input: {} },
        { instanceId: 'rattigheter', blockRef: 'samtycke_sarskilda_bilaga.rattigheter@v1', input: {} },
    ];
}
const FORM_NUMBER = 'Formulär R-23';
const META = {
    category: 'Övriga avtal',
    shortTitle: 'Samtycke särskilda kategorier (bilaga)',
    formNumber: FORM_NUMBER,
    preamble: SAMTYCKE_PREAMBLE,
    description: SAMTYCKE_DESCRIPTION +
        '\n\nSkapas som bilaga under ett bostads- eller studentbostadsavtal — visas inte i avtalslistan, har ingen egen signering. Parter och avtalsnummer hämtas från avtalet. Bifogas det signerade avtalet automatiskt vid utskick via Scrive.\n\n' +
        'Behöver dokumentet signeras separat (utan ett kopplat hyresavtal) — använd den fristående mallen "Samtycke särskilda kategorier" under Övriga avtal.',
    statute: SAMTYCKE_STATUTE,
    signingMode: 'parent',
    numberStyle: 'paragraph',
    partySlots: [],
    attachableTo: ['bostadshyra', 'studentbostad'],
    singletonPerParent: true,
};
export const samtyckeSarskildaBilagaV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'samtycke_sarskilda_bilaga',
    documentVersion: 'v1',
    title: SAMTYCKE_TITLE,
    locale: 'sv-SE',
    meta: META,
    values,
    blocks: [
        ...letterheadAndFooter(SAMTYCKE_TITLE, FORM_NUMBER),
        ...samtyckeSharedBody('samtycke_sarskilda_bilaga'),
        { instanceId: 'samtycke', blockRef: 'samtycke_sarskilda_bilaga.samtycke@v1', input: {} },
    ],
});
//# sourceMappingURL=samtycke_sarskilda_bilaga.js.map